import React from "react"


export default function Footer() {
  return (
    <footer className="footer">
        <h3>PCCOE&R ACM Chapter</h3>
        <p>Designed and Built by PCCOER ACM WebTeam</p>
    </footer>

  )
}
